import React from 'react';
import FormGroupSelectInput from "../formGroupSelectInput";
import FormGroupPlainText from "../formGroupPlainText";
import accounting from "accounting";
import { CURRENCY } from '../../helpers/variables';

const LoiCard = (props) => {
    return (
        <div className={'loiCard'}>
            <span className={'loiCard__header'}>{props.label}</span>
            <form className={'form-horizontal'}>
                <FormGroupSelectInput
                    Label={'LOI'}
                    LeftWrapper="col-sm-6"
                    Required={false}
                    Name={props.productId}
                    Value={props.products[props.productId].limitOfIndemnity}
                    Options={props.loi}
                    HandleInputChange={(evt) => props.handleQuoteProductsChange({
                        key: evt.target.name,
                        value: evt.target.value
                    })}
                    CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                    SelectStyle={'form-control formGroupSelectInput-select'}
                />
                <FormGroupPlainText
                    labelWrapper="col-xs-6"
                    Label={'Automatic Cover:'}
                    InputWrapper="manageSolicitorAccount-data col-xs-6 text-right"
                    Text={accounting.formatMoney(parseFloat(props.productInfo.automaticCover), `${CURRENCY} `, 2)}
                />
                {
                    parseFloat(props.productInfo.contractAndDept)?
                        <FormGroupPlainText
                            labelWrapper="col-xs-6"
                            Label={'C&D Recovery:'}
                            InputWrapper="manageSolicitorAccount-data col-xs-6 text-right"
                            Text={accounting.formatMoney(parseFloat(props.productInfo.contractAndDept), `${CURRENCY} `, 2)}
                        />
                        :
                        null
                }
                <FormGroupPlainText
                    labelWrapper="col-xs-6"
                    Label={'Premium:'}
                    InputWrapper="manageSolicitorAccount-data col-xs-6 text-right"
                    Text={accounting.formatMoney(parseFloat(props.productInfo.premium), `${CURRENCY} `, 2)}
                />
                <FormGroupPlainText
                    labelWrapper="col-xs-6"
                    Label={`IPT(${props.productInfo.ipt.taxPercentage}%):`}
                    InputWrapper="manageSolicitorAccount-data col-xs-6 text-right"
                    Text={accounting.formatMoney(parseFloat(props.productInfo.ipt.value), `${CURRENCY} `, 2)}
                />
                <FormGroupPlainText
                    labelWrapper="col-xs-6"
                    Label={'Total Premium:'}
                    InputWrapper="manageSolicitorAccount-data col-xs-6 text-right"
                    Text={accounting.formatMoney(parseFloat(props.productInfo.totalPremium), `${CURRENCY} `, 2)}
                />
            </form>
        </div>
    )
};

export default LoiCard;